import { Validator } from '@vista-digital/validator';
import { defaultFilmTrailerButtonAssets, filmTrailerButtonAssetsValidator } from '../../trailer-button/types/assets';
import { defaultFilmDetailsCdnOptions, filmDetailsCdnOptionsValidator } from './cdn-options';
import { defaultFilmDetailsConfig, filmDetailsConfigValidator } from './config';
import { defaultFilmDetailsDisplayText, filmDetailsDisplayTextValidator } from './display-text';
import { filmDetailsEventsValidator } from './events';
export const filmDetailsPropsValidator = Validator.object({
    displayText: filmDetailsDisplayTextValidator,
    assets: filmTrailerButtonAssetsValidator,
    config: filmDetailsConfigValidator,
    events: filmDetailsEventsValidator,
    cdnOptions: filmDetailsCdnOptionsValidator
});
export const defaultFilmDetailsProps = {
    displayText: defaultFilmDetailsDisplayText,
    assets: defaultFilmTrailerButtonAssets,
    config: defaultFilmDetailsConfig,
    events: {},
    cdnOptions: defaultFilmDetailsCdnOptions
};
//# sourceMappingURL=props.js.map